import Button from 'components/Button'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Radio from 'components/Form/RadioButton'
import RichEditor from 'components/RichEditor'
import Select from 'components/Select'
import {
  FlexWrap,
  FormItem,
  RadioGroup,
  RedText,
  SecondaryHeading,
} from 'components/UIComponents/FormStyles'
import PlusIcon from 'components/icons/PlusIcon'
import React, { useEffect, useState } from 'react'
const externalassesmentOptions = [
  {
    label: 'Test Gorilla',
    value: 'TEST_GORILA',
    disabled: false,
    text: 'testgorilla',
  },
  {
    label: 'eSkill',
    value: 'E_SKILL',
    disabled: false,
    text: 'eskill',
  },
]
const EvaluationForm = ({
  sortedItems,
  setSortedItems,
  roundValues,
  setRoundValues,
  isEditingForm,
  setIsEditingForm,
  currentId,
  setCurrentId,
  handleEditDelete,
  isEditRoleOnView,
  disableNameField,
  singleRoleData,
  setDisableNameField,
  setEditText,
  editText,
  onAddNewRound,
}) => {
  const [duplicateRoundName, setDuplicateRoundName] = useState(false)
  const [externalAssessmentOptions, setExternalAssessmentOptions] = useState(
    externalassesmentOptions
  )
  const RadioOptions = [
    {
      id: 1,
      label: 'Assessment',
      value: 'ASSESMENT',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Group Discussion',
      value: 'GROUP',
      disabled: isEditRoleOnView,
    },
    {
      id: 3,
      label: 'Interview',
      value: 'FACE_TO_FACE',
      disabled: isEditRoleOnView,
    },
    {
      id: 4,
      label: 'External Assessment',
      value: 'EXTERNAL_ASSESMENT',
      disabled: isEditRoleOnView,
    },
  ]
  const assessmentOptions = [
    {
      id: 1,
      label: 'Cognitive',
      value: 'COGNITIVE',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Technical',
      value: 'TECHNICAL',
      disabled: isEditRoleOnView,
    },
    {
      id: 3,
      label: 'Communication',
      value: 'COMUNICATION',
      disabled: isEditRoleOnView,
    },
  ]

  const faceToFaceOptions = [
    {
      label: 'Domain Experts',
      value: 'DOMAIN_EXPERTS',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'HR Round',
      value: 'HR_ROUND',
      disabled: isEditRoleOnView,
    },
  ]

  const handleFilter = input => {
    if (!input) {
      setExternalAssessmentOptions(externalassesmentOptions)
    } else {
      const filtered = externalassesmentOptions.filter(
        option =>
          option.label.toLowerCase().includes(input.toLowerCase()) ||
          option.text.toLowerCase().includes(input.toLowerCase())
      )
      setExternalAssessmentOptions(filtered)
    }
  }

  const handleOnChange = (value, key) => {
    setRoundValues({ ...roundValues, [key]: value, [key + 'Error']: '' })

    if (key == 'roundName') {
      if (
        sortedItems
          ?.map(item => item?.name?.toLowerCase())
          ?.includes(value?.toLowerCase()?.trim())
      ) {
        setDuplicateRoundName(true)
        setRoundValues({
          ...roundValues,
          [key]: value,
          [key + 'Error']: 'Round name already exist.',
        })
      } else {
        setDuplicateRoundName(false)
        setRoundValues({ ...roundValues, [key]: value, [key + 'Error']: '' })
      }
    }
    if (key == 'interviewType') {
      setRoundValues({
        ...roundValues,
        assessmentType: '',
        [key]: value,
        [key + 'Error']: '',
      })
    }
    if (key == 'assessmentType') {
      setExternalAssessmentOptions(externalassesmentOptions)
    }
  }

  const handleSubmit = async () => {
    let isValid = true
    let localState = roundValues
    if (!roundValues.roundName) {
      isValid = false
      localState = { ...localState, roundNameError: 'Please Enter round name' }
    }
    if (!roundValues.interviewType) {
      isValid = false
      localState = {
        ...localState,
        interviewTypeError: 'Please Select round type',
      }
    }
    if (
      (roundValues.interviewType == 'ASSESMENT' ||
        roundValues.interviewType == 'EXTERNAL_ASSESMENT') &&
      !roundValues.assessmentType
    ) {
      isValid = false
      localState = {
        ...localState,
        assessmentTypeError:
          roundValues.interviewType == 'ASSESMENT'
            ? 'Please Select assessment type'
            : 'Please select external assessment type',
      }
    } else {
      localState = {
        ...localState,
        assessmentTypeError: '',
      }
    }
    if (
      roundValues.interviewType == 'FACE_TO_FACE' &&
      !roundValues.faceToFaceType
    ) {
      isValid = false
      localState = {
        ...localState,
        faceToFaceTypeError: 'Please Select Face To Face Type',
      }
    } else {
      localState = {
        ...localState,
        faceToFaceTypeError: '',
      }
    }
    if (
      !roundValues.roundDescription ||
      roundValues.roundDescription == '<p><br></p>'
    ) {
      isValid = false
      localState = {
        ...localState,
        roundDescriptionError: 'Please enter description',
      }
    }
    if (isValid && !duplicateRoundName) {
      if (isEditingForm) {
        let newData = sortedItems?.map(item =>
          (item?.name === currentId ? true : '')
            ? {
                name: roundValues.roundName?.trim(),
                type: roundValues.interviewType.toUpperCase(),
                assesmentType: roundValues.assessmentType.toUpperCase(),
                description: roundValues.roundDescription,
                faceToFaceType: roundValues.faceToFaceType.toUpperCase(),
                id: roundValues.id ?? '',
              }
            : item
        )
        setSortedItems(newData)
      } else if (sortedItems?.length) {
        setSortedItems(prevSortedItems => {
          return [
            ...prevSortedItems,
            {
              name: roundValues.roundName?.trim(),
              type: roundValues.interviewType.toUpperCase(),
              assesmentType: roundValues.assessmentType.toUpperCase(),
              faceToFaceType: roundValues.faceToFaceType.toUpperCase(),
              description: roundValues.roundDescription,
            },
          ]
        })
      } else {
        setSortedItems([
          {
            name: roundValues.roundName?.trim(),
            type: roundValues.interviewType.toUpperCase(),
            assesmentType: roundValues.assessmentType.toUpperCase(),
            faceToFaceType: roundValues.faceToFaceType.toUpperCase(),
            description: roundValues.roundDescription,
          },
        ])
      }

      clearAll()
    } else {
      setRoundValues(localState)
    }
  }
  const clearAll = () => {
    setEditText(prevState => !prevState)
    setRoundValues({
      ...roundValues,
      roundName: '',
      roundNameError: '',
      interviewType: '',
      interviewTypeError: '',
      assessmentType: '',
      assessmentTypeError: '',
      roundDescription: '',
      faceToFaceTypeError: '',
      faceToFaceType: '',
      roundDescriptionError: '',
      id: '',
    })
    setIsEditingForm(false)
    setCurrentId('')
    setDisableNameField(false)
  }
  useEffect(() => {
    setEditText(false)
  }, [editText])

  let roundsCount = sortedItems?.length ?? 0
  return (
    (!singleRoleData?.isInterviewScheduled || isEditingForm) && (
      <div style={{ scrollPaddingTop: '300px' }} id="editForm">
        {!isEditingForm && (
          <SecondaryHeading>Round {roundsCount + 1}</SecondaryHeading>
        )}

        <div>
          <Input
            type="text"
            width="100%"
            label="Round name *"
            placeholder="Add Round Name"
            value={roundValues?.roundName}
            onChange={({ target }) => {
              handleOnChange(target.value, 'roundName')
            }}
            status={roundValues?.roundNameError && 'error'}
            disabled={disableNameField}
          />
          <RedText className={'ant-form-item-explain-error'}>
            {roundValues?.roundNameError}{' '}
          </RedText>
        </div>

        <div>
          <Label>Evaluation type *</Label>
          <FormItem>
            <RadioGroup
              flexFlow="wrap"
              onChange={({ target }) =>
                handleOnChange(target.value, 'interviewType')
              }
              value={roundValues.interviewType}
            >
              {RadioOptions?.map((item, index) => (
                <Radio
                  key={index + item?.value}
                  border={true}
                  label={item?.label}
                  value={item?.value}
                  disabled={singleRoleData?.isInterviewScheduled}
                />
              ))}
            </RadioGroup>
          </FormItem>
          <RedText className={'ant-form-item-explain-error'}>
            {roundValues?.interviewTypeError}
          </RedText>
        </div>
        {roundValues?.interviewType == 'ASSESMENT' ? (
          <div>
            <Label>Assessment Type *</Label>
            <FormItem>
              <RadioGroup
                spaceBetween
                onChange={({ target }) =>
                  handleOnChange(target.value, 'assessmentType')
                }
                value={roundValues.assessmentType}
              >
                {assessmentOptions?.map((item, index) => (
                  <Radio
                    width={'30%'}
                    key={index + item?.value}
                    border={true}
                    label={item?.label}
                    value={item?.value}
                    disabled={singleRoleData?.isInterviewScheduled}
                  />
                ))}
              </RadioGroup>
            </FormItem>
            <RedText className={'ant-form-item-explain-error'}>
              {roundValues?.assessmentTypeError}
            </RedText>
          </div>
        ) : roundValues?.interviewType == 'FACE_TO_FACE' ? (
          <div>
            <Label>Face To Face Type *</Label>
            <FormItem>
              <RadioGroup
                onChange={({ target }) =>
                  handleOnChange(target.value, 'faceToFaceType')
                }
                gap="37px"
                value={roundValues.faceToFaceType}
              >
                {faceToFaceOptions?.map((item, index) => (
                  <Radio
                    width={'30%'}
                    key={index + item?.value}
                    border={true}
                    label={item?.label}
                    value={item?.value}
                    disabled={singleRoleData?.isInterviewScheduled}
                  />
                ))}
              </RadioGroup>
            </FormItem>
            <RedText className={'ant-form-item-explain-error'}>
              {roundValues?.faceToFaceTypeError}
            </RedText>
          </div>
        ) : roundValues?.interviewType == 'EXTERNAL_ASSESMENT' ? (
          <div>
            <div>
              <Label>External Assessment Type *</Label>
              <FormItem>
                <Select
                  value={roundValues.assessmentType}
                  onChange={value => handleOnChange(value, 'assessmentType')}
                  showSearch={true}
                  allowClear={true}
                  OptionData={externalAssessmentOptions}
                  filterOption={false}
                  valueParam="value"
                  nameParam="label"
                  placeholder="Select External Assessment Type"
                  disabled={singleRoleData?.isInterviewScheduled}
                  width="25%"
                  onSearch={handleFilter}
                />
              </FormItem>
              <RedText className={'ant-form-item-explain-error'}>
                {roundValues?.assessmentTypeError}
              </RedText>
            </div>
          </div>
        ) : null}
        <div>
          <FormItem>
            <RichEditor
              labelName="Round description *"
              placeholder="E.g.  There is no negative marking."
              value={roundValues?.roundDescription}
              onChange={data => handleOnChange(data, 'roundDescription')}
              editText={editText}
            />
          </FormItem>
        </div>
        <RedText className={'ant-form-item-explain-error'}>
          {roundValues?.roundDescriptionError}
        </RedText>
        <div id="section1"></div>
        {isEditingForm ? (
          <FlexWrap gap="20px">
            <Button.Secondary
              text={'Cancel'}
              width="100%"
              onClick={() => handleEditDelete('', 'cancel')}
            />
            <Button.Secondary
              text={'Update Round'}
              width="100%"
              dashed="true"
              onClick={handleSubmit}
              id="editRoundsButton"
            />
          </FlexWrap>
        ) : (
          <Button.Secondary
            text={'Add Rounds'}
            width="100%"
            icon={<PlusIcon color="#3249D7" />}
            dashed="true"
            onClick={handleSubmit}
            id="addRoundsButton"
          />
        )}
      </div>
    )
  )
}

export default EvaluationForm
